import { formatToUSDateTimeWith12Hour } from 'utils/dateTimeUtils/dateFormatUtil';

import ApplicationsGridRowWrapper from 'components/ApplicationsGrid/components/ApplicationsGridRowWrapper';
import GridText from 'components/text/GridText';
import TableLink from 'components/text/TableLink';

import usePageRoutes from 'hooks/usePageRoutes';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const ApplicationsGridRow = ({
    id,
    lastActivity,
    lastEdited,
    name,
    ref,
    status,
    style,
    testId = TEST_ID
}: Props) => {
    const { applicationDetailsPage } = usePageRoutes();
    const { APPLICATION_STATUS } = useTranslation();

    const formattedStatus = status ? APPLICATION_STATUS(status) : '-';

    return (
        <ApplicationsGridRowWrapper ref={ref} style={style} testId={testId}>
            <TableLink className={styles.tableLink} text={name} to={applicationDetailsPage(id)} />

            <GridText text={formattedStatus} />

            <GridText text={lastEdited ? formatToUSDateTimeWith12Hour(lastEdited) : '-'} />

            <GridText text={lastActivity ?? '-'} />
        </ApplicationsGridRowWrapper>
    );
};

export default ApplicationsGridRow;
